import React from 'react'

type RadioOption = {
  value: string
  label: string
}

type RadioGroupProps = {
  name: string
  options: RadioOption[]
  value?: string
  onChange: (value: string) => void
  label?: string
  orientation?: 'horizontal' | 'vertical'
  error?: string
  helper?: string
  className?: string
}

export const RadioGroup: React.FC<RadioGroupProps> = ({
  name,
  options,
  value,
  onChange,
  label,
  orientation = 'horizontal',
  error,
  helper,
  className = '',
}) => (
  <div className={`w-full ${className}`}>
    {label && (
      <label className="font-din-pro-medium text-base text-altovita block mb-2">
        {label}
      </label>
    )}

    <div
      className={`
        radio-group flex
        ${orientation === 'horizontal' ? 'flex-row' : 'flex-col space-y-2'}
      `}
    >
      {options.map((option, index) => {
        let borderClasses = ''
        if (orientation === 'horizontal') {
          if (index === 0) {
            borderClasses = 'rounded-l-lg border-r-0'
          } else if (index === options.length - 1) {
            borderClasses = 'rounded-r-lg'
          } else {
            borderClasses = 'border-r-0'
          }
        } else {
          borderClasses = 'rounded-lg'
        }

        return (
          <label
            key={option.value}
            className={`
                radio-option flex items-center cursor-pointer border border-border-color transition-all duration-200
                ${borderClasses}
                ${value === option.value ? 'bg-light-bg border-altovita' : 'bg-white hover:bg-gray-50'}
                px-4 py-3
              `}
          >
            <input
              type="radio"
              name={name}
              value={option.value}
              checked={value === option.value}
              onChange={(e) => onChange(e.target.value)}
              // eslint-disable-next-line max-len
              className="w-5 h-5 border-2 border-border-color rounded-full bg-white mr-3 appearance-none relative checked:border-altovita checked:after:content-[''] checked:after:absolute checked:after:top-1/2 checked:after:left-1/2 checked:after:transform checked:after:-translate-x-1/2 checked:after:-translate-y-1/2 checked:after:w-2.5 checked:after:h-2.5 checked:after:bg-altovita checked:after:rounded-full"
            />
            <span
              className={`font-din-pro-regular text-base ${
                value === option.value
                  ? 'text-altovita font-din-pro-medium'
                  : 'text-grey-text'
              }`}
            >
              {option.label}
            </span>
          </label>
        )
      })}
    </div>

    {error && <p className="mt-1 text-sm text-red-600">{error}</p>}

    {helper && !error && (
      <p className="mt-1 text-sm text-grey-text">{helper}</p>
    )}
  </div>
)
